import { useAll, useById } from "@hulanbv/nest-utilities-client-state";
import { FC } from "react";
import { useParams } from "react-router";
import { dictionary } from "../../state/common/constants/dictionary.constants";
import { userService } from "../../state/user/user.service";
import { BoxShadowHead } from "../elements/box-shadow-head.element";
import { Flex } from "../elements/flex.element";
import { Header } from "../elements/header.element";
import { PageBody } from "../elements/page-body.element";
import { Page } from "../elements/page.element";
import { SvgIcon } from "../elements/svg-icon.element";
import { ReactComponent as checkIcon } from "../../assets/graphics/symbols/checkmark.svg";
import { locale } from "../../constants/locale.constants";
import { activityEntriesService } from "../../state/activities/activity-entries.service";
import { activityTypeLabels } from "../../state/activities/activity-type-labels";
import { TableRowContent } from "../elements/table-row-content.element";
import { TableRow } from "../elements/table-row.element";

export const ActivityEntrySessionResultsScreen: FC = () => {
  const params = useParams<{
    sessionId: string;
    userId: string;
    exerciseInviteId: string;
  }>();

  const { data: user } = useById(userService, params.userId, {
    select: ["name", "lastName"],
  });

  const { data: activityEntries } = useAll(activityEntriesService, {
    match: {
      sessionIdentifier: params.sessionId,
    },
    populate: [
      {
        path: "exerciseInvite",
        populate: [{ path: "exercise", select: ["name"] }],
      },
    ],
  });
  const exerciseName = activityEntries?.[0]?.exerciseInvite?.exercise?.name;
  const activityType = activityEntries?.[0]?.activityType ?? null;
  const completionDate = activityEntries?.[0]?.createdAt
    ? new Date(activityEntries[0].createdAt)
    : null;

  return (
    <Page>
      <PageBody fullWidth>
        <BoxShadowHead>
          <Flex direction="column" alignItems="flex-start" gap={10}>
            <Header>
              {activityType !== null && activityTypeLabels[activityType]}
            </Header>
            {exerciseName && <Header size={"small"}>{exerciseName}</Header>}
            <Header size={"small"}>
              {user?.name} {user?.lastName}
            </Header>
            {completionDate && (
              <Flex gap={10}>
                <SvgIcon
                  icon={checkIcon}
                  color={"rgb(var(--color-black))"}
                  width={20}
                  height={20}
                />
                <Header size={"small"}>
                  {dictionary.literals.completedOn}{" "}
                  {completionDate.toLocaleDateString(locale)}
                </Header>
              </Flex>
            )}
          </Flex>
        </BoxShadowHead>
        {activityEntries?.map((entry) => (
          <TableRow key={entry._id}>
            <TableRowContent
              header={entry.input}
              subHeader={entry.value}
              subHeaderSize="tiny"
            />
          </TableRow>
        ))}
      </PageBody>
    </Page>
  );
};
